import styled from 'styled-components'
import globalTheme from './theme'
import { DolaThemeProps } from './types'

const Separator = styled.div<DolaThemeProps>`
  border-top: 1px solid ${({ dolaTheme }) => globalTheme[dolaTheme].border};
`

export default Separator
